<template>
  <div class="def-modal" :class="{ 'def-modal_padding': padding }">
    <slot />
    <span v-if="isShowClose" class="def-modal__close" @click="$emit('close')">
      <svg
        class="def-modal__icon"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.40002 1.33936L14.6607 13.6L13.6 14.6607L1.33936 2.40002L2.40002 1.33936Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.6607 2.40002L2.40002 14.6607L1.33936 13.6L13.6 1.33936L14.6607 2.40002Z"
        />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DefModal',
  props: {
    padding: {
      type: [Boolean, undefined],
      default: true,
    },
    isShowClose: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-modal {
  height: 100%;
  max-height: 100vh;
  overflow-y: auto;
  background-color: #fff;
  position: relative;
  width: 100%;
  @include point-md {
    max-height: 90vh;
  }
  &_padding {
    padding: 48px 24px;
    @include point-md {
      padding: 48px;
    }
  }
  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
    z-index: 1;
    &:hover {
      .def-modal__icon {
        fill: var(--background-red);
      }
    }
  }
  &__icon {
    display: block;
    width: 16px;
    height: 16px;
    fill: #757575;
    transition: 0.2s linear fill;
  }
}
</style>
